import { render, staticRenderFns } from "./package.vue?vue&type=template&id=da6a400e&scoped=true&"
import script from "./package.vue?vue&type=script&lang=js&"
export * from "./package.vue?vue&type=script&lang=js&"
import style0 from "./package.vue?vue&type=style&index=0&id=da6a400e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6a400e",
  null
  
)

export default component.exports